import '../../Default.css'
import './Reviews.css'
import { Carousel, Flex } from "antd"
import { FC, useContext, useState } from "react"
import { ReactGoogleReview, ReactGoogleReviews } from "react-google-reviews"
import "react-google-reviews/dist/index.css"
import { ResponsiveContext } from "../../context/responsive-context"
import Card from 'antd/es/card/Card'
import { ReviewCard } from './ReviewCard'

export const Reviews: FC = () => {
  const { isMobile } = useContext(ResponsiveContext)
  const contentStyle: React.CSSProperties = {
  margin: 0,
  height: '160px',
  color: '#fff',
  lineHeight: '160px',
  textAlign: 'center',
  background: '#364d79',
}

  const featurableWidgetId = "c986589c-8bfb-453c-af18-2d596c6366f1"
  return (
    <Flex
      className="Default-container Reviews-container"
      vertical
    >
    <Flex
      className="Reviews-header"
      vertical
      justify={'end'}
    >
      <div className={isMobile ? "Review-header-head-mobile" : "Review-header-head"}>Vendégeim visszajelzései</div>
      <div className={isMobile ? "Review-header-body-mobile" : "Review-header-body"}>avagy ilyen volt a tanácsadás</div>
    </Flex>
    <Flex
      className="Reviews-body"
      vertical
      justify={'space-around'}
      align={'center'}
      >
    <ReactGoogleReviews
      featurableId={featurableWidgetId}
      layout="badge"
      />
    <ReactGoogleReviews
      featurableId={featurableWidgetId}
      layout="custom"
      disableTranslation
      renderer={(reviews) => {
        return (
          <ReviewCard reviews={[...reviews]} />

        )}
      }
    />
    </Flex>
    </Flex>

  )
}
